import axios from "axios";
import { API_PATH } from "./index";

//export const gen = (formdata) => axios.post(`http://192.168.2.52:7509/servlet`, formdata).then(res => res.data);
export const listResources = () => axios.get(API_PATH + `/listResources`).then(res => res.data);

export const resPath = (section, file, version = "latest") => `${API_PATH}/resources/${section}/${file}?version=${version}`;